export const decodePermissions = (encoded) => {
  try {
    return JSON.parse(atob(encoded));
  } catch (e) {
    console.warn("Invalid permissions data");
    return [];
  }
};

export const hasPermission = (permission) => {
  const permissions = decodePermissions(permission);
  return permissions;
};

// Hook cho React
export const usePermissions = () => {
  const encoded = localStorage.getItem("permissions");
  const permissions = encoded ? decodePermissions(encoded) : [];

  return {
    permissions,
    can: (permission) => permissions.includes(permission),
    cannot: (permission) => !permissions.includes(permission),
  };
};
